import React from 'react';
import { RefreshIcon } from '@heroicons/react/solid';
import { Link } from 'react-router-dom';

const TradeCanceledBanner = ({trade, isReciever}) => {


    return (
        <div className="bg-red-200">
            <div className="max-w-7xl mx-auto py-3 px-4 sm:px-4 lg:py-6 lg:px-8 lg:flex lg:items-center lg:justify-between">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 md:text-md">
                    {isReciever ? 
                        <span className="block text-2xl sm:text-xl">Trade with {trade.senderName} has been canceled!</span>
                        :
                        <span className="block text-2xl sm:text-xl">Trade with {trade.recieverName} has been canceled!</span>
                    }
                    <span className='block text-indigo-600 flex text-sm'>{trade.recieverItemName} <RefreshIcon className='h-5 w-5 mx-2'/>
                        {trade.senderItemsNames && trade.senderItemsNames.map((senderItemName,i) => (
                            <div key={i}>
                                {senderItemName} 
                                {trade.senderItemsNames.length > 1 && i+1 !== trade.senderItemsNames.length 
                                    ? <> +&nbsp;</> 
                                    : <> </>
                                }  
                            </div>
                        ))}
                    </span>


                </h2>
                <div className="mt-8 lg:flex lg:mt-0 lg:flex-shrink-0">
                    <Link to='/trades'>
                        <button
                            type="button"
                            className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-red-500 "

                        >
                            Back to trades
                        </button>
                    </Link>

                </div>
            </div>
        </div>

    );
};

export default TradeCanceledBanner;

